import { useState } from "react";
import { StyleSheet } from "react-native";
import { IconButton, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import Menu from "../Menu";
import type { MenuAction } from "./types";

const OVERFLOW_MENU_ITEMS: { title: MenuAction; leadingIcon: string }[] = [
	{ title: "Share", leadingIcon: "share-variant-outline" },
	{ title: "Report", leadingIcon: "flag-outline" },
];

const ICON_SIZE = 24;

type BottomActionsRowProps = {
	playbackSpeed: number;
	isBookmarked: boolean;
	isInPlaylist: boolean;
	compact?: boolean;
	onChangeSpeed: () => void;
	onTogglePlaylist: () => void;
	onToggleBookmark: () => void;
	onMenuItemPress?: (action: MenuAction) => void;
};

const BottomActionsRow = ({
	playbackSpeed,
	isBookmarked,
	isInPlaylist,
	compact,
	onChangeSpeed,
	onTogglePlaylist,
	onToggleBookmark,
	onMenuItemPress,
}: BottomActionsRowProps) => {
	const theme = useAppTheme();
	const [menuVisible, setMenuVisible] = useState(false);

	return (
		<Box
			flexDirection="row"
			alignItems="center"
			justifyContent={compact ? undefined : "space-between"}
			width={compact ? undefined : "100%"}
			paddingHorizontal={compact ? 0 : 4}
			gap={compact ? 12 : undefined}
		>
			<IconButton
				icon={() => (
					<Text
						variant="labelLarge"
						style={{ color: theme.colors.onSurfaceVariant }}
					>
						{`${playbackSpeed.toFixed(1)}x`}
					</Text>
				)}
				size={ICON_SIZE}
				onPress={onChangeSpeed}
				style={styles.actionButton}
				accessibilityLabel={`Playback speed ${playbackSpeed.toFixed(1)}x`}
			/>
			<IconButton
				icon={isInPlaylist ? "playlist-check" : "playlist-play"}
				size={24}
				onPress={onTogglePlaylist}
				iconColor={theme.colors.onSurfaceVariant}
				style={styles.actionButton}
				accessibilityLabel={
					isInPlaylist ? "Remove from playlist" : "Add to playlist"
				}
			/>
			<IconButton
				icon={isBookmarked ? "bookmark" : "bookmark-outline"}
				size={ICON_SIZE}
				onPress={onToggleBookmark}
				iconColor={theme.colors.onSurfaceVariant}
				style={styles.actionButton}
				accessibilityLabel={isBookmarked ? "Remove bookmark" : "Bookmark"}
			/>
			<Menu
				visible={menuVisible}
				onDismiss={() => setMenuVisible(false)}
				anchor={
					<IconButton
						icon="dots-horizontal"
						size={ICON_SIZE}
						onPress={() => setMenuVisible(true)}
						iconColor={theme.colors.onSurfaceVariant}
						style={styles.actionButton}
						accessibilityLabel="More options"
					/>
				}
				items={OVERFLOW_MENU_ITEMS}
				onItemPress={(item) => {
					setMenuVisible(false);
					onMenuItemPress?.(item.title as MenuAction);
				}}
			>
				{null}
			</Menu>
		</Box>
	);
};

const styles = StyleSheet.create({
	actionButton: {
		width: 48,
		height: 48,
	},
});

export default BottomActionsRow;
